import { z } from 'zod'

const typeEnum = z.enum([
  'COTTAGE',
  'village',
  'province',
  'region',
  'country',
  'zone',
])

export const schema = z.object({
  suggestions: z.array(
    z.discriminatedUnion('type', [
      z.object({
        type: typeEnum.extract(['COTTAGE']),
        name: z.string(),
        denomination: z.string().nullable().optional(),
        parentName: z.string().nullable().optional(),
        description: z.string().nullable().optional(),
        url: z.string(),
        location: z.null(),
      }),
      z.object({
        type: typeEnum.extract([
          'village',
          'province',
          'region',
          'country',
          'zone',
        ]),
        name: z.string(),
        denomination: z.string().nullable().optional(),
        parentName: z.string().nullable().optional(),
        description: z.string().nullable().optional(),
        url: z.null(),
        location: z.string(),
      }),
    ]),
  ),
  words: z.array(z.string()),
})

export type schemaType = z.infer<typeof schema>

export const paramsSchema = z.object({
  query: z.string(),
  province: z.string().optional(),
  region: z.string().optional(),
})

export type paramsType = z.infer<typeof paramsSchema>

export type returnType = ApiServerResponse<schemaType>
